import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import InputNumber from 'component/form/InputNumber'
import LabelInputValid from '../utils/LabelInputValid'

class LmExpressParameterForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      inLotOrHue: !!props.records.inLotOrHue,
      inControlled: !!props.records.inControlled,
      inHighRisk: !!props.records.inHighRisk,
      inValue: props.records.inValue !== '0',
      nrValue: props.records.inValue,
    }
  }

  componentDidMount() {
    const { records } = this.props

    this.setState({
      inLotOrHue: !!records.inLotOrHue,
      inControlled: !!records.inControlled,
      inHighRisk: !!records.inHighRisk,
      inValue: records.inValue !== '0',
      nrValue: records.inValue,
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.records.inLotOrHue !== prevProps.records.inLotOrHue ||
      this.props.records.inControlled !== prevProps.records.inControlled ||
      this.props.records.inHighRisk !== prevProps.records.inHighRisk ||
      this.props.records.inValue !== prevProps.records.inValue
    ) {
      /* eslint-disable */
      this.setState({
        inLotOrHue: !!this.props.records.inLotOrHue,
        inControlled: !!this.props.records.inControlled,
        inHighRisk: !!this.props.records.inHighRisk,
        inValue: this.props.records.inValue !== '0',
        nrValue: this.props.records.inValue,
      })
      /* eslint-enable */
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { onSubmit } = this.props

    const params = {
      ...this.state,
    }

    onSubmit(params)
  }

  handleClick = (event) => {
    const { setValueToField } = this.props
    const { target } = event

    if (target.name === 'inValue') {
      this.setState({ nrValue: '' })
    }

    setValueToField(target.name, target.checked)
    this.setState({ [target.name]: target.checked })
  }

  handleChange = (event) => {
    const { target } = event

    this.setState({ nrValue: target.value })
  }

  customInputLabel = () => {
    const { translate } = this.props
    const { inValue, nrValue } = this.state

    return (
      <span>
        {translate('lmexpress.parameter.nrValue')}

        <InputNumber
          type='text'
          id='nrValue'
          name='nrValue'
          label=''
          value={nrValue}
          onChange={this.handleChange}
          disabled={inValue === '0'}
          separator='.'
          delimiter=''
        />
      </span>
    )
  }

  render() {
    const { translate } = this.props

    const field = this.props.fields

    const { inLotOrHue, inControlled, inHighRisk, inValue } = this.state

    return (
      <Col md={8} mdOffset={4}>
        <Row>
          <Col md={8}>
            <form className='LmExpressParametersForm'>
              <fieldset>
                <Row>
                  <Col xs={12}>
                    <legend>
                      {translate('lmexpress.parameter.editTitle')}
                    </legend>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12}>
                    <LabelInputValid
                      id={'inLotOrHue'}
                      name={field.inLotOrHue}
                      error={translate(field.inLotOrHue.error)}
                      labelLeft={translate('lmexpress.parameter.inLotOrHue')}
                      inputClassName={'custom-input'}
                      onChange={this.handleClick}
                      type={'checkbox'}
                      checked={inLotOrHue}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12}>
                    <LabelInputValid
                      id={'inControlled'}
                      name={field.inControlled}
                      error={translate(field.inControlled.error)}
                      labelLeft={translate('lmexpress.parameter.inControlled')}
                      inputClassName={'custom-input'}
                      onChange={this.handleClick}
                      type={'checkbox'}
                      checked={inControlled}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12}>
                    <LabelInputValid
                      id={'inHighRisk'}
                      name={field.inHighRisk}
                      error={translate(field.inHighRisk.error)}
                      labelLeft={translate('lmexpress.parameter.inHighRisk')}
                      inputClassName={'custom-input'}
                      onChange={this.handleClick}
                      type={'checkbox'}
                      checked={inHighRisk}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12}>
                    <LabelInputValid
                      id={'inValue'}
                      name={field.inValue}
                      error={translate(field.inValue.error)}
                      labelLeft={this.customInputLabel()}
                      inputClassName={'custom-input'}
                      onChange={this.handleClick}
                      type={'checkbox'}
                      checked={inValue}
                    />
                  </Col>
                </Row>
              </fieldset>

              <Row className='margin-top-double margin-bottom'>
                <Col xs={8} md={6}>
                  <button
                    role='button'
                    type='button'
                    className='button button-primary button-full'
                    onClick={this.handleSubmit}
                  >
                    {translate('save_button_label')}
                  </button>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Col>
    )
  }
}

LmExpressParameterForm.propTypes = {
  fields: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
  records: PropTypes.object.isRequired,
}

const fields = ['inLotOrHue', 'inControlled', 'inHighRisk', 'inValue']

export default Form({ fields })(LmExpressParameterForm)

export { LmExpressParameterForm }
